import { _StoreWithGetters, PiniaCustomProperties, _StoreWithState } from 'pinia';
import { UnwrapRef } from 'vue';

import { RelatedPatientGetters } from './getters';

import { Patient } from 'fhir/r4';
import { RelatedPatientStateInterface } from './state';

import {
  relatedPatientsAdd,
  relatedPatientsList,
  relatedPatientsRemove,
  relatedPatientsUpdate
} from 'src/services/functions';
import mixpanel from 'mixpanel-browser';

type RelatedPatientActions = {
  get(): Promise<void>;
  add(patient: Patient): Promise<void>;
  remove(patient: Patient): Promise<void>;
  update(patient: Patient): Promise<void>;
};

const actions: RelatedPatientActions &
  ThisType<
    RelatedPatientActions &
      UnwrapRef<RelatedPatientStateInterface> &
      _StoreWithState<
        string,
        RelatedPatientStateInterface,
        RelatedPatientGetters,
        RelatedPatientActions
      > &
      _StoreWithGetters<RelatedPatientGetters> &
      PiniaCustomProperties
  > = {
  async get() {
    const result = await relatedPatientsList();
    result.forEach(el => {
      el.id = String(el._id);
    });
    this.$state.list = result;
  },
  async add(patient) {
    const result = await relatedPatientsAdd(patient);
    if (result.insertedId) {
      mixpanel.track('Related Patient add');
      this.list.push({ id: String(result.insertedId), ...patient });
    } else {
      throw Error('Patient not added');
    }
  },
  async update(patient: Patient) {
    if (!patient.id) throw Error('Patient id not in the payload');
    if (!this.list.find(el => el.id === patient.id))
      throw Error('Patient not found');
    const result = await relatedPatientsUpdate(patient);
    if (!result.modifiedCount) throw Error('Nothing updated');
    const index = this.list.findIndex(el => el.id === patient.id);
    if (index != -1) {
      let telecom = this.list[index].telecom?.filter((el) => el.system === 'email') || [];
      telecom = telecom.concat(patient.telecom?.filter((el) => el.system !== 'email') || [])
      this.list[index] = { ...patient, telecom };
    }
    else this.list.push(patient);
  },
  async remove(patient: Patient) {
    if (!patient.id) throw Error('Patient id not in payload');
    await relatedPatientsRemove(patient.id);
    const index = this.list.findIndex(value => value.id === patient.id);
    if (index != -1) this.list.splice(index, 1);
    mixpanel.track('Related Patient remove');
  }
};

export default actions;
